import { ConfigStore } from "../../store/modules/config";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import { appConfig } from "../../config"

export class AuthNavigationVue extends Vue {
  /** Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get windowWidth(): number {
    return this.configStore.windowWidth;
  }

  /** Список ссылок в меню */
  links: Array<any> = [
    {
      title: i18n.t("auth.nav.aboutSystem"),
      url: appConfig.aboutSystemUrl,
      exact: true
    },
    {
      title: i18n.t("auth.nav.atm"),
      url: appConfig.atmUrl,
      exact: true
    },
    {
      title: i18n.t("auth.nav.contacts"),
      url: appConfig.contactsUrl
    }
  ];

  /** Признак видимости правого меню */
  isMenuOpen: boolean = false;

  /** Меняет признак видимости правого меню */
  hideShowMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
